// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminSampleSettings = (client) => ({
    /**
     * `POST /admin/sample-settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpsertSampleSettings
     * @source packages/modules/b2c-core/src/api/admin/sample-settings/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/sample-settings", { method: "POST", body, query, headers }),
    /**
     * `GET /admin/sample-settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetSampleSettings
     * @source packages/modules/b2c-core/src/api/admin/sample-settings/route.ts
     */
    list: (query, headers) => client.fetch("/admin/sample-settings", { method: "GET", query, headers }),
});
//# sourceMappingURL=sample-settings.js.map